<script>
    import {GPContextInpainting} from "./gp-context-inpainting.js";
    import {getGPTransFunc} from "./gp-translations";
    import {somethingDrawn} from "./gp-context-inpainting.js";

    let trans = getGPTransFunc("gp-inpainting");

    function cutObject (){
        if ($somethingDrawn)
            GPContextInpainting.inpaintObjects();
    }

</script>

<div id="GPInpainting">
    <div>
        <p>
            <img src="img/inpaintingExample.png"/>
            {trans("Paint over the object on the background image, such as a plant, that should be removed from the background")}.
            <br/><br/>
            {trans("Once an object is marked, press the button below")}.
        </p>
        <div class="GPInpaintingActions">
            <button on:click={cutObject} id="GPInpaintConfirm" type="button" class="btn btn-default" class:disabled={$somethingDrawn===false}>{trans("Remove object")}</button>
        </div>
    </div>
</div>
